<template>
  <w-radio-list
    :title="title"
    :model="schema.$eq || schema.$exists"
    :values="filter.options"
    @input="$emit('update')"
  />
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz przedziału liczb
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true },
    // filtr
    filter: { type: Object, required: true },
    // tytuł pola
    title: { type: String, required: true }
  }
};
</script>
